"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConvertPassesToCreditsBodyToJSON = exports.ConvertPassesToCreditsBodyFromJSONTyped = exports.ConvertPassesToCreditsBodyFromJSON = void 0;
function ConvertPassesToCreditsBodyFromJSON(json) {
    return ConvertPassesToCreditsBodyFromJSONTyped(json, false);
}
exports.ConvertPassesToCreditsBodyFromJSON = ConvertPassesToCreditsBodyFromJSON;
function ConvertPassesToCreditsBodyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'passAmount': json['passAmount'],
        'userAddress': json['userAddress'],
        'tokenIds': json['tokenIds'],
    };
}
exports.ConvertPassesToCreditsBodyFromJSONTyped = ConvertPassesToCreditsBodyFromJSONTyped;
function ConvertPassesToCreditsBodyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'passAmount': value.passAmount,
        'userAddress': value.userAddress,
        'tokenIds': value.tokenIds,
    };
}
exports.ConvertPassesToCreditsBodyToJSON = ConvertPassesToCreditsBodyToJSON;
